import React, { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { adminApi } from "../../lib/portalApi";
import { toast } from "sonner";
import { Save, Mail } from "lucide-react";

export default function EmailTemplatesTab() {
  const [rows, setRows] = useState([]);
  const [drafts, setDrafts] = useState({});
  const [active, setActive] = useState(null);

  const load = async () => {
    const r = await adminApi.emailList();
    const t = r.templates || [];
    setRows(t);
    const d = {};
    t.forEach(row => { d[row.key] = { subject: row.subject || "", body: row.body || "" }; });
    setDrafts(d);
    if (!active && t.length) setActive(t[0].key);
  };
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const save = async (key) => {
    try {
      await adminApi.emailPut(key, drafts[key]);
      toast.success(`Template "${key}" saved`);
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Save failed"); }
  };

  const upd = (key, f, v) => setDrafts({ ...drafts, [key]: { ...drafts[key], [f]: v } });
  const d = active ? drafts[active] : null;

  return (
    <div className="space-y-4" data-testid="admin-email-tab">
      <div className="flex gap-2 flex-wrap">
        {rows.map(r => (
          <button key={r.key} onClick={() => setActive(r.key)}
            className={`text-[11px] uppercase tracking-[0.18em] px-3 py-1.5 rounded border transition-colors ${
              active === r.key
                ? "bg-navy-soft text-gold border-gold"
                : "text-cream-dim border-gold-dim/30 hover:text-gold"
            }`}
            data-testid={`email-template-${r.key}`}>
            {r.key}
          </button>
        ))}
      </div>

      {d && active && (
        <div className="glass p-5 space-y-3" data-testid="email-editor">
          <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.22em] text-electric">
            <Mail size={12} /> {active}
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.22em] text-steel">Subject</label>
            <Input value={d.subject} onChange={e => upd(active, "subject", e.target.value)}
              className="bg-navy-deep border-gold-dim/40 mt-1" data-testid="email-subject" />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.22em] text-steel">Body (supports {`{{variables}}`})</label>
            <Textarea rows={10} value={d.body} onChange={e => upd(active, "body", e.target.value)}
              className="bg-navy-deep border-gold-dim/40 mt-1 text-cream font-mono text-sm"
              data-testid="email-body" />
          </div>
          <div className="flex justify-end">
            <Button onClick={() => save(active)} className="btn-gold h-10 px-5 text-xs"
              data-testid="email-save-btn">
              <Save size={14} className="mr-2" /> Save Template
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
